import { Promotion } from "@/_models/promotion.interface";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import {
    AssignedItemMeta,
    AssignedItemMetaService,
    EMPTY_ASSIGNED_ITEM_META,
} from "@/_services/assigned-item-meta.service";
import { listItemTitle } from "@/_utility/list-item-title.util";
import { RECORD_TYPE_BADGES } from "@/_utility/record-type-badge.util";
import { AssignedItemMetaComponent } from "../assigned-item-meta/assigned-item-meta.component";
import { Component, Input, OnChanges } from "@angular/core";
import { TagModule } from "primeng/tag";

@Component({
    selector: "app-promotion-task-card",
    standalone: true,
    imports: [
        SharedComponentsModule,
        AssignedItemMetaComponent,
        CombinedTaskCardMobileComponent,
        TagModule,
    ],
    templateUrl: "./promotion-task-card.component.html",
    styleUrls: [
        "./promotion-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class PromotionTaskCardComponent implements OnChanges {
    @Input() promotion: Promotion;
    @Input() showEdit: boolean = false;

    badge = RECORD_TYPE_BADGES.promotion;
    title: string = this.badge.untitledTitle;
    meta: AssignedItemMeta = EMPTY_ASSIGNED_ITEM_META;

    constructor(private metaService: AssignedItemMetaService) {}

    ngOnChanges(): void {
        this.title = listItemTitle(this.promotion, this.badge.untitledTitle);
        this.meta = this.metaService.forPromotion(this.promotion);
    }
}
